
//define a function
function hamburger__click() {
  if ($(".jsHamburger").length > 0) {
    $("header .jsHamburger").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("is-menu-visible");
    });
    $(document).click(function (e) {
      var container = $("header");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.parents("body").removeClass("is-menu-visible");
      }
    });
  }
}

function current__year() {
  if ($("#year").length > 0) {
    var date = new Date();
    var year = date.getFullYear();
    document.getElementById("year").innerHTML = year;
  }
}

function loadTop(){
  if ($('header').length > 0) {
    $(window).on('beforeunload', function() {
      $(window).scrollTop(0);
    });

    $(document).ready(function() {
      setTimeout(function() {
        window.scrollTo(0, 0);
      }, 100);
    });
  }
}
  

function handleHeaderScroll() {
  if ($("header").length > 0) {

    const $header = $("body > header");
    const scrollThreshold = 50;
  
    if (!$header.length) {
      return;
    }
  
    $(window).on("scroll", function () {
      const currentScroll = $(window).scrollTop();
  
      if (currentScroll > scrollThreshold) {
        $header.addClass("header-scrolled");
      } else {
        $header.removeClass("header-scrolled");
      }
    });

    
  }
}

function fadeOutBody(){
  // Handle clicks on internal links
  $("a[href$='.html']").not(".scroll-to__icon").on("click", function(event) {
    event.preventDefault();
    var newLocation = this.href;
    $("body").fadeOut(300, function() {
      window.location = newLocation;
    });
  });

  // Handle browser navigation
  window.addEventListener('popstate', function() {
    $("body").fadeOut(300, function() {
      window.location = window.location.href;
    });
  });

  // Store page state on unload
  window.addEventListener('unload', function() {
    sessionStorage.setItem('fadeEffect', 'true');
  });

  // Check for fade effect on page load
  if (sessionStorage.getItem('fadeEffect')) {
    $("body").hide().fadeIn(300);
    sessionStorage.removeItem('fadeEffect');
  } else {
    $("body").fadeIn(300);
  }
}


function lenisSmooth() {
  if ($("header").length > 0) {
 
    const lenis = new Lenis({
      autoRaf: true,
      smooth: true,
    });
  
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
  
    requestAnimationFrame(raf);
  }
}

function customCursor(){
  if ($('#cursor').length > 0) {
    const cursor = document.querySelector('.cursor');
    const heroBanner = document.querySelector('.section--hero-banner');
    
    // Initially hide cursor
    cursor.style.opacity = '0';
  
    document.addEventListener('mousemove', e => {
        // Check if mouse is over hero banner
        const isOverHeroBanner = heroBanner && heroBanner.contains(e.target);
        
        if (!isOverHeroBanner) {
          // Show cursor when not over hero banner
          cursor.style.opacity = '1';
          
          // Use clientX/Y instead of pageX/Y to handle scroll position
          const x = e.clientX - 12;
          const y = e.clientY - 12;
          
          // Use transform instead of top/left for better performance
          cursor.style.transform = `translate(${x}px, ${y}px)`;
        } else {
          // Hide cursor over hero banner
          cursor.style.opacity = '0';
        }
    });
  
    // Handle click animation
    document.addEventListener('click', e => {
        const isOverHeroBanner = heroBanner && heroBanner.contains(e.target);
        if (!isOverHeroBanner) {
          cursor.classList.add("expand");
          setTimeout(() => {
              cursor.classList.remove("expand");
          }, 400)
        }
    });
  
    // Handle hover on anchor tags
    document.querySelectorAll('a, iframe').forEach(link => {
        link.addEventListener('mouseenter', e => {
          const isOverHeroBanner = heroBanner && heroBanner.contains(e.target);
          if (!isOverHeroBanner) {
            cursor.classList.add("expand");
          }
        });
        
        link.addEventListener('mouseleave', e => {
          const isOverHeroBanner = heroBanner && heroBanner.contains(e.target);
          if (!isOverHeroBanner) {
            cursor.classList.remove("expand");
          }
        });
    });
  }
  
}

function servicesActiveHome(){
  if ($('.our-service__item').length > 0) {
    let items = $(".our-service__item");
    let index = 0;

    function activateItem() {
        items.removeClass("is-active"); // Remove active class from all items
        items.eq(index).addClass("is-active"); // Add active class to the current item
        index = (index + 1) % items.length; // Move to the next item, loop back if at the end
    }

    activateItem(); // Activate the first item immediately
    setInterval(activateItem, 3000); // Repeat every 3 seconds
  }
}

function headerDark(){
  if ($('header').length > 0) {
    // Only run if body has theme--transparent class
    if (!$('body').hasClass('theme--transparent')) {
      return;
    }
  
    var $header = $(".header");
    var $sections = $(".section--light");
    var headerHeight = $header.outerHeight(); // Get the header height
  
    function checkHeaderDark() {
        var scrollTop = $(window).scrollTop();
        var isDarkApplied = false;
  
        $sections.each(function () {
            var sectionTop = $(this).offset().top - headerHeight;
            var sectionBottom = sectionTop + $(this).outerHeight();
  
            if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
                isDarkApplied = true;
            }
        });
  
        if (isDarkApplied) {
            $header.addClass("is-dark");
        } else {
            $header.removeClass("is-dark");
        }
    }
  
    // Check on page load
    checkHeaderDark();
  
    // Check on scroll
    $(window).on("scroll", checkHeaderDark);
  }
}

function servicesAccordion(){
  
  $('.services-accordion__item').on('click', function() {
    const $item = $(this);
    const $header = $item.find('.services-accordion__item-header');
    const $content = $item.find('.services-accordion__item-content');
    const $allContents = $('.services-accordion__item-content');
    const $allHeaders = $('.services-accordion__item-header');
    
    // Close all other accordions
    $allContents.not($content).removeClass('active');
    $allHeaders.not($header).removeClass('active');
    
    // Toggle current accordion
    $header.toggleClass('active');
    $content.toggleClass('active');
});
}

function contactForm(){
  // Handle main contact form
  if ($('#contact-form').length > 0) {
    $(document).ready(function () {
      $("#contact-form").on("submit", function (e) {
          e.preventDefault();
          
          if (!this.checkValidity()) {
            e.preventDefault();
            $(this).addClass("was-validated");
            return;
          }
  
          var form = $(this);
          var submitButton = form.find("button[type='submit']");
          var successMessage = $(".contact-success");
          var failureMessage = $(".contact-failure");
  
          submitButton.text("Sending...").prop("disabled", true);
  
          $.ajax({
              type: "POST", 
              url: form.attr("action"),
              data: form.serialize() + "&isContactForm=true", // Add flag to identify contact form
              success: function (response) {
                  submitButton.text("Send Message").prop("disabled", false);
                  successMessage.addClass("is-visible");
                  setTimeout(function () {
                      successMessage.removeClass("is-visible");
                  }, 5000);
                  form[0].reset();
              },
              error: function () {
                  submitButton.text("Send Message").prop("disabled", false);
                  failureMessage.addClass("is-visible");
                  setTimeout(function () {
                      failureMessage.removeClass("is-visible");
                  }, 5000);
              }
          });
      });
    });
  }

  // Handle footer newsletter form
  if ($('#footer-form').length > 0) {
    $(document).ready(function () {
      $("#footer-form").on("submit", function (e) {
          e.preventDefault();
          
          if (!this.checkValidity()) {
            e.preventDefault();
            $(this).addClass("was-validated");
            return;
          }
  
          var form = $(this);
          var successMessage = form.find(".contact-success");
          var failureMessage = form.find(".contact-failure");
          var sendingLoader = form.find(".contact-loader");

          sendingLoader.addClass("is-visible");
  
          $.ajax({
              type: "POST",
              url: form.attr("action"), 
              data: form.serialize() + "&isNewsletterForm=true", // Add flag to identify newsletter form
              success: function (response) {
                  sendingLoader.removeClass("is-visible");
                  successMessage.addClass("is-visible");

                  setTimeout(function () {
                      successMessage.removeClass("is-visible");
                  }, 5000);
                  form[0].reset();
              },
              error: function () {
                  sendingLoader.removeClass("is-visible");
                  failureMessage.addClass("is-visible");
                  setTimeout(function () {
                      failureMessage.removeClass("is-visible");
                  }, 5000);
              }
          });
      });
    });
  }
}


function smoothScrollTo(){
  $(".scroll-to__icon").on("click", function (event) {
    event.preventDefault(); // Prevent default anchor click behavior

    var target = $(this).attr("href"); // Get the target section ID
    if (target && $(target).length) {
        $("html, body").animate(
            {
                scrollTop: $(target).offset().top
            },
            800 // Duration of the animation in milliseconds
        );
    }
});
}



$(window).on("load", function () {
  if ($('body').hasClass('is-home')) {
    setTimeout(function() {
      $('body').addClass('is-ready');
    }, 300);
  }
  
  AOS.init({
    once: true,
    mirror: false,
    offset: 50,
    anchorPlacement: 'bottom-bottom' // Triggers when the item reaches the bottom of the viewport
  });
  lenisSmooth();
  headerDark();
});

$(document).ready(function () {
  // fadeOutBody();
  smoothScrollTo();
  loadTop();
  contactForm();
  customCursor();
  handleHeaderScroll();
  hamburger__click();
  servicesActiveHome();
  servicesAccordion();
});
